import { GridColDef, GridColumns } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../cells/base-cell';

export function VersionColumns(): GridColDef[] {
  const { t } = useTranslation();
  const columns: GridColumns = [
    {
      field: 'field',
      headerName: t(`global.field`),
      width: 200,
      renderCell: baseCell
    },
    {
      field: 'oldValue',
      headerName: t(`global.old-value`),
      width: 500,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'newValue',
      headerName: t(`global.new-value`),
      width: 500,
      sortable: false,
      renderCell: baseCell
    }
  ];
  return columns;
}
